/** Stable codes mapped under `auth.form_errors` in translations. */
export type AuthFormErrorCode =
  | "no_account_associated"
  | "invalid_username_or_password"
  | "failed_to_create_account"
  | "failed_to_change_password"
  | "failed_to_send_password_reset_email"
  | "failed_to_reset_password"
  | "failed_to_create_password"
  | "failed_to_join"
  | "failed_to_link_account"
  | "failed_to_confirm_authentication_request"
  | "account_already_exists"

export class AuthFormError extends Error {
  readonly code: AuthFormErrorCode
  readonly i18nParams: Record<string, string>

  constructor(
    code: AuthFormErrorCode,
    i18nParams: Record<string, string> = {}
  ) {
    super(code)
    this.name = "AuthFormError"
    this.code = code
    this.i18nParams = i18nParams
  }
}

export const isAuthFormError = (e: unknown): e is AuthFormError =>
  e instanceof AuthFormError

type TranslateFn = (key: string, options?: Record<string, string>) => string

export const getAuthFormErrorMessage = (
  error: unknown,
  t: TranslateFn
): string => {
  if (isAuthFormError(error)) {
    return t(`auth.form_errors.${error.code}`, error.i18nParams)
  }
  if (error instanceof Error) {
    return error.message
  }
  return String(error)
}
